<div class="ai-application-bar-trigger"
     #megaPromptPopoverTarget>
    <div class="ai-application-bar-item"
         data-test="chat-ai-appbar-item"
         (click)="showChatClient()">
        <i class="fas fa-fw fa-stars"></i>
    </div>

    @if (applicableMegaPromptLabels.length > 0) {
        <i class="fas fa-fw fa-caret-down ai-application-bar-caret"
           [ngClass]="{'fa-bounce': pulseMegaPrompt}"></i>
        <dx-popover [target]="megaPromptPopoverTarget"
                    showEvent="dxpointerenter"
                    [hideEvent]="{ name: 'dxpointerleave', delay: 300 }"
                    [(visible)]="popoverVisible"
                    [minWidth]="220"
                    position="bottom"
                    (onContentReady)="onPopoverContentReady($event)"
                    (onShowing)="popoverCancelHiding = false"
                    (onHiding)="onPopoverHiding($event)">
            <div class="prompts-list">
                <span>Execute preset prompt...</span>
                <dx-list [items]="applicableMegaPromptLabels"
                         displayExpr="label"
                         (onItemClick)="onMegaPromptItemClick($event)"></dx-list>
            </div>
        </dx-popover>
    }
</div>
